module.exports = __webpack_public_path__ + "img/news18_4.ed26f9c9.jpg";